import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

export const getSalesInvoiceBankSlip = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_bank_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createSalesInvoiceBankPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", data.payment_date)
    formData.append("bank_from", data.bank_from)
    formData.append(
      "from_account_no",
      data.from_account_no ? data.from_account_no : ""
    )
    formData.append(
      "from_account_name",
      data.from_account_name ? data.from_account_name : ""
    )
    formData.append("bank_to", data.bank_to)
    formData.append("to_account_no", data.to_account_no)
    formData.append("to_account_name", data.to_account_name)
    formData.append(
      "transaction_fee",
      data.transaction_fee ? data.transaction_fee : 0
    )
    formData.append("reference_no", data.reference_no ? data.reference_no : "")
    formData.append("customer_id", data.customer_id)
    formData.append("payee", data.payee)
    formData.append("commission", data.commission ? data.commission : 0)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("acknowledged_by", data.acknowledged_by)

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_bank_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSalesInvoiceBankPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file, index) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("sales_invoice_bank_slip_id", data.id)
    formData.append("payment_date", data.payment_date)
    formData.append("bank_from", data.bank_from)
    formData.append("from_account_no", data.from_account_no)
    formData.append("from_account_name", data.from_account_name)
    formData.append("bank_to", data.bank_to)
    formData.append("to_account_no", data.to_account_no)
    formData.append("to_account_name", data.to_account_name)
    formData.append(
      "transaction_fee",
      data.transaction_fee ? data.transaction_fee : 0
    )
    formData.append("reference_no", data.reference_no)
    formData.append("customer_id", data.customer_id)
    formData.append("payee", data.payee)
    formData.append("commission", data.commission ? data.commission : 0.0)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("acknowledged_by", data.acknowledged_by.value)

    // formData.append("total_sales", data.total_sales);
    // formData.append("vat_sales", data.vat_sales);
    // formData.append("vat", data.vat);
    // formData.append("withholding_tax", data.withholding_tax);
    // formData.append("wht_percentage", data.wht_percentage);
    // formData.append("grand_total", data.grand_total);

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_bank_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesInvoiceBankPayment = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      sales_invoice_bank_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_bank_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
